var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotswhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 6,
    viewBox: "0 0 20 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 1.33325C10.9204 1.33325 11.6666 2.07944 11.6666 2.99992C11.6666 3.92039 10.9204 4.66658 9.99996 4.66659C9.07949 4.66659 8.33329 3.92039 8.33329 2.99992C8.33329 2.07944 9.07949 1.33325 9.99996 1.33325Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33329 1.33325C4.25377 1.33325 4.99996 2.07944 4.99996 2.99992C4.99996 3.92039 4.25377 4.66658 3.33329 4.66659C2.41282 4.66659 1.66663 3.92039 1.66663 2.99992C1.66663 2.07944 2.41282 1.33325 3.33329 1.33325Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 1.33325C17.5871 1.33325 18.3333 2.07944 18.3333 2.99992C18.3333 3.92039 17.5871 4.66658 16.6666 4.66659C15.7462 4.66659 15 3.92039 15 2.99992C15 2.07944 15.7462 1.33325 16.6666 1.33325Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotswhite);
export default __webpack_public_path__ + "static/media/dotswhite.4ad4732c9ed2bd21762af1cc5aa1447b.svg";
export { ForwardRef as ReactComponent };